import { css } from "@linaria/core"
import { styled } from "@linaria/react"

import { Button } from "@/components/Button/Button.tsx"
import { Vertical } from "@/components/Flex.ts"

export const HomeStyles = {
  PageTitle: styled.h1`
    font-family: var(--heading-font-family), sans-serif;
    font-size: 24px;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -0.03px;
    text-align: center;

    margin: 0;

    color: var(--secondary-text-color);
  `,

  PageSubtitle: styled.h2`
    font-family: var(--heading-font-family), sans-serif;
    font-size: 54px;
    font-weight: 600;
    line-height: 60px;
    letter-spacing: -0.04px;
    text-align: center;

    margin: 0 0 24px;

    color: var(--text-color);
  `,

  PageCloseButton: styled(Button)`
    position: absolute;
    right: 20px;
    top: 20px;

    color: var(--secondary-text-color);

    transition: color 0.2s ease-in-out;

    &:focus-visible {
      color: var(--text-color);
    }

    &:hover:not(:disabled) {
      color: var(--text-color);
    }
  `,

  List: styled(Vertical)`
    gap: 16px;

    width: 80%;
    min-width: 560px;
    max-width: var(--limited-centered-width);

    @media (width <= 700px) {
      width: 100%;
      min-width: auto;
    }

    margin-bottom: 8px;
  `,

  ListTitle: styled.div`
    color: var(--secondary-text-color);
    margin: 0 8px;

    &:not(:first-child) {
      margin-top: 32px;
    }
  `,

  ListEmpty: styled.div`
    margin: 0 8px;
  `,

  StarIcon: css`
    color: var(--starred-color);
  `
}
